import styled from "styled-components";
import { RATypography, RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { useEffect, useRef } from "react";
import { useState } from "react";

const { useBreakpoint } = Grid;
export function JourneyMilestone({ historyContent, active = null, scrollDirection = null }) {
	const screens = useBreakpoint();
	const introductionRef = useRef(null);
	const itemsRef = useRef([]);
	const [timelineMovementOffset, setTimelineMovementOffset] = useState(245);
	const [isEnough3Sides, setIsEnough3Sides] = useState(false);

	useEffect(() => {
		if (active >= 0 && active < historyContent.timelines.length) {
			if (scrollDirection === "down") {
				if (active > 0 && active < historyContent.timelines.length) {
					setTimelineMovementOffset((prev) => prev - itemsRef.current[active - 1]?.offsetHeight);
				}
				if (active === 0) {
					setTimelineMovementOffset((isEnough3Sides ? introductionRef?.current?.offsetHeight : 0) + 60);
				}
			} else if (scrollDirection === "up") {
				if (active !== historyContent.timelines.length - 1 && active > 0) {
					setTimelineMovementOffset((prev) => prev + itemsRef.current[active]?.offsetHeight);
				} else if (active === 0) {
					setTimelineMovementOffset((prev) => prev + itemsRef.current[active]?.offsetHeight);
				}
			}
		} else if (active < 0) {
			setTimelineMovementOffset(introductionRef?.current?.offsetHeight + itemsRef.current[0]?.offsetHeight);
		}
	}, [active]);

	useEffect(() => {
		itemsRef.current = itemsRef.current.slice(0, historyContent.timelines.length);
		let max3 = 0;

		for (let i = 0; i < historyContent.timelines.length - 2; i++) {
			if (
				max3 <
				itemsRef.current[i]?.offsetHeight +
					itemsRef.current[i + 1]?.offsetHeight +
					itemsRef.current[i + 2]?.offsetHeight
			) {
				max3 =
					itemsRef.current[i]?.offsetHeight +
					itemsRef.current[i + 1]?.offsetHeight +
					itemsRef.current[i + 2]?.offsetHeight;
			}
		}
		if (max3 < window.innerHeight * 0.9 - introductionRef?.current?.offsetHeight) {
			setIsEnough3Sides(true);
		}
	}, [historyContent]);

	return (
		<HistoryContainer>
			<div style={{ position: "relative", width: "100%" }}>
				<MilestonesContainer>
					<DescriptionContainer ref={introductionRef}>
						<Row justify="center">
							<Col md={24}>
								<WrapperContent>
									<RATypography variant={screens?.md ? "h2" : "h4"} align="center">
										{historyContent?.title || ""}
									</RATypography>
								</WrapperContent>
								<Row justify="center">
									<Col xl={20} lg={20} md={20} sm={20} xs={24}>
										<RATypography variant="body3" top="20px" color="#595959" align="center">
											{historyContent?.sub_title || ""}
										</RATypography>
									</Col>
								</Row>
							</Col>
						</Row>
					</DescriptionContainer>
					<div
						style={{
							transition: "all 0.6s linear",
							paddingTop: screens?.lg ? "50px" : "0",
							flexGrow: 1,
							transform: `translateY(${timelineMovementOffset}px)`,
						}}
					>
						{active !== null &&
							historyContent.timelines?.map((timelineSwiper, indexSwiper) => {
								return (
									<div
										ref={(el) => (itemsRef.current[indexSwiper] = el)}
										key={indexSwiper}
										style={{
											transition: "all 0.6s linear",
											width: "100%",
										}}
									>
										<MileStoneCard
											active={active === indexSwiper}
											slideIn={
												isEnough3Sides
													? (scrollDirection === "down" &&
															active + 1 <= historyContent?.timelines.length &&
															indexSwiper === active + 1) ||
														(scrollDirection === "up" &&
															active - 1 >= 0 &&
															indexSwiper === active - 1)
													: (scrollDirection === "down" &&
															active + 1 <= historyContent?.timelines.length &&
															indexSwiper === active + 1) ||
														(scrollDirection === "up" &&
															active >= 0 &&
															indexSwiper === active)
											}
											slideOut={
												isEnough3Sides
													? (scrollDirection === "down" &&
															active - 2 >= 0 &&
															indexSwiper === active - 2) ||
														(scrollDirection === "up" &&
															active + 2 <= historyContent?.timelines.length &&
															indexSwiper === active + 2)
													: (scrollDirection === "down" &&
															active - 1 >= 0 &&
															indexSwiper === active - 1) ||
														(scrollDirection === "up" &&
															active + 2 <= historyContent?.timelines.length &&
															indexSwiper === active + 2)
											}
											hide={
												isEnough3Sides
													? indexSwiper < active - 1 || indexSwiper > active + 1
													: indexSwiper < active || indexSwiper > active + 1
											}
											index={indexSwiper}
											timeline={timelineSwiper}
										/>
									</div>
								);
							})}
					</div>
				</MilestonesContainer>
			</div>
		</HistoryContainer>
	);
}

const MileStoneCard = ({ index = 0, timeline, active = false, preActive = false, hide, slideIn, slideOut }) => {
	const screens = useBreakpoint();
	const { title, description, year, icon } = timeline || {};
	const setPadding = () => {
		return screens?.lg
			? index % 2 === 0
				? "0 0 0 30px"
				: "0 30px 0 0"
			: screens?.sm
				? "16px 0 0 48px"
				: "0 0 0 30px";
	};

	return (
		<div
			className={`animate__animated ${
				slideIn &&
				!slideOut &&
				(screens?.lg
					? index % 2 === 0
						? "animate__backInRight"
						: "animate__backInLeft"
					: "animate__backInRight")
			} ${slideOut && !slideIn ? "animate__fadeOut" : ""} ${hide ? "hidden" : ""}`}
			style={{ height: "100%" }}
		>
			<Row
				style={{
					height: "100%",
					position: "relative",
					left: screens?.lg ? (index % 2 === 0 ? "-1px" : "1px") : "0px",
				}}
				wrap={false}
			>
				<Col
					xxl={{ span: 12, order: index % 2 === 0 ? 2 : 1 }}
					xl={{ span: 12, order: index % 2 === 0 ? 2 : 1 }}
					lg={{ span: 12, order: index % 2 === 0 ? 2 : 1 }}
					md={{ span: 24, order: 1 }}
					sm={{ span: 24, order: 1 }}
					xs={{ span: 24, order: 1 }}
					style={{
						borderLeft: screens?.lg
							? index % 2 === 0
								? `2px solid ${active ? "#FFB11A" : "#A8A8A8"}`
								: "none"
							: `2px solid ${active ? "#FFB11A" : "#A8A8A8"}`,
						borderRight: screens?.lg
							? index % 2 === 0
								? "none"
								: `2px solid ${active ? "#FFB11A" : "#A8A8A8"}`
							: "none",
						paddingBottom: "72px",
					}}
				>
					<Row
						style={{
							width: "100%",
							position: "absolute",
							top: screens?.lg ? "-40px" : screens?.xs ? "-40px" : "-72px",
							padding: setPadding(),
						}}
						justify={screens?.lg ? (index % 2 === 0 ? "start" : "end") : "start"}
					>
						<RATypography variant="h3">{year}</RATypography>
					</Row>
					<Row
						align="middle"
						justify={screens?.lg ? (index % 2 === 0 ? "start" : "end") : "start"}
						style={{ padding: screens?.lg ? 0 : "0 0 0 16px" }}
					>
						<DotOuter
							style={{
								transition: "all 0.6s linear",
								backgroundColor: active ? "#FFB11A" : "#A8A8A8",
								left: screens?.lg ? (index % 2 === 0 ? "-12px" : "calc(100% - 12px)") : "-12px",
							}}
						>
							<DotInner> </DotInner>
						</DotOuter>
						<div
							style={{
								transition: "all 0.6s linear",
								width: "calc(100% - 44px)",
								height: 2,
								backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23${
									active ? "FFB11A" : "A8A8A8"
								}' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
							}}
						></div>
						<IconContainer
							style={{
								transition: "all 0.6s linear",
								right: screens?.lg ? (index % 2 === 0 ? "1px" : "calc(100% - 45px)") : "1px",
							}}
							color={active ? "#FFB11A" : "#A8A8A8"}
						>
							<img src={icon} />
						</IconContainer>
					</Row>
					<Row
						style={{
							marginTop: 8,
							padding: setPadding(),
						}}
						justify={screens?.lg ? (index % 2 === 0 ? "start" : "end") : "start"}
					>
						<RATypography
							variant="sub-heading4"
							color="#222222"
							align={screens?.lg ? (index % 2 === 0 ? "left" : "right") : "left"}
						>
							{title}
						</RATypography>
					</Row>

					<Row
						style={{
							padding: setPadding(),
						}}
						justify={screens?.lg ? (index % 2 === 0 ? "start" : "end") : "start"}
					>
						<RATypography
							variant="body3"
							align={screens?.lg ? (index % 2 === 0 ? "left" : "right") : "left"}
							color="#222222"
							style={{ opacity: 0.7 }}
						>
							{description}
						</RATypography>
					</Row>
				</Col>
				<Col
					xxl={{ span: 12, order: index % 2 === 0 ? 1 : 2 }}
					xl={{ span: 12, order: index % 2 === 0 ? 1 : 2 }}
					lg={{ span: 12, order: index % 2 === 0 ? 1 : 2 }}
					md={{ span: 24, order: 2 }}
					sm={{ span: 24, order: 2 }}
					xs={{ span: 24, order: 1 }}
				></Col>
			</Row>
		</div>
	);
};

const MilestoneIcon = ({ active = false }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
			<circle
				cx="22"
				cy="22"
				r="21.5769"
				transform="matrix(-1 0 0 1 44 0)"
				// stroke="#A8A8A8"
				strokeWidth="0.846154"
			/>
			<path
				d="M29.4084 25.8696V25.8986H29.4374H31.6654C31.8954 25.8986 32.0821 26.0852 32.0821 26.3152V32.5536C32.0821 32.7836 31.8954 32.9703 31.6654 32.9703H30.3575V28.0976C30.3575 27.8357 30.1449 27.6231 29.883 27.6231H27.2094C26.9474 27.6231 26.7348 27.8357 26.7348 28.0976V32.9703H12.0589C11.8289 32.9703 11.6422 32.7837 11.6422 32.5536V26.3152C11.6422 26.0852 11.8289 25.8986 12.0589 25.8986H12.5045H12.5334V25.8697V19.1857C12.5334 18.9557 12.7201 18.769 12.9501 18.769H13.2228H13.2629L13.2502 18.7309L12.5551 16.6437L12.5551 16.6437C12.5409 16.601 12.5334 16.5569 12.5334 16.512V14.7296C12.5334 14.4996 12.7201 14.3129 12.9501 14.3129H15.1781H15.207V14.284V12.056C15.207 11.826 15.3937 11.6393 15.6237 11.6393C15.8537 11.6393 16.0404 11.826 16.0404 12.056V14.284V14.3129H16.0693H18.2973C18.5273 14.3129 18.714 14.4996 18.714 14.7296V16.512C18.714 16.5568 18.7065 16.601 18.6923 16.6436L18.6923 16.6436L17.9972 18.7309L17.9845 18.7689H18.0246H18.2973C18.5273 18.7689 18.714 18.9556 18.714 19.1856V25.8696V25.8986H18.7429H23.1989H23.2278V25.8696V24.5328C23.2278 24.3028 23.4145 24.1161 23.6445 24.1161H28.9918C29.2218 24.1161 29.4084 24.3028 29.4084 24.5328V25.8696ZM16.9886 22.7793H16.9895V22.7504V20.968C16.9895 20.706 16.7769 20.4935 16.5149 20.4935H14.7325C14.4706 20.4935 14.258 20.706 14.258 20.968V22.7504C14.258 23.0124 14.4706 23.2249 14.7325 23.2249H16.5149C16.7671 23.2249 16.9736 23.0278 16.9886 22.7793ZM20.5534 29.909H20.5543V29.8801V28.0976C20.5543 27.8357 20.3417 27.6231 20.0797 27.6231H18.2973C18.0354 27.6231 17.8228 27.8357 17.8228 28.0976V29.8801C17.8228 30.142 18.0354 30.3546 18.2973 30.3546H20.0797C20.3319 30.3546 20.5384 30.1575 20.5534 29.909ZM15.6237 30.3546C15.8856 30.3546 16.0982 30.142 16.0982 29.8801V28.0976C16.0982 27.8357 15.8856 27.6231 15.6237 27.6231H13.8413C13.5793 27.6231 13.3667 27.8357 13.3667 28.0976V29.8801C13.3667 30.142 13.5793 30.3546 13.8413 30.3546H15.6237ZM14.7325 16.9865H16.5149C16.7768 16.9865 16.9895 16.774 16.9895 16.512C16.9895 16.2501 16.7769 16.0375 16.5149 16.0375H14.7325C14.4706 16.0375 14.258 16.2501 14.258 16.512C14.258 16.7739 14.4706 16.9865 14.7325 16.9865ZM24.5357 30.3546C24.7977 30.3546 25.0103 30.142 25.0103 29.8801V28.0976C25.0103 27.8357 24.7977 27.6231 24.5357 27.6231H22.7533C22.4914 27.6231 22.2788 27.8357 22.2788 28.0976V29.8801C22.2788 30.142 22.4914 30.3546 22.7533 30.3546H24.5357Z"
				fill="#595959"
				stroke="#A8A8A8"
				strokeWidth="0.0578425"
			/>
			<path
				d="M32.6747 16.8755C32.8806 16.7311 33.0027 16.4887 33.0009 16.2267C33 15.9656 32.8744 15.724 32.6649 15.5797C31.9341 15.0797 31.1579 15.0182 30.3968 15.388L27.8711 16.5751L27.7963 16.6197L26.2331 15.8024C25.5798 15.3675 24.833 15.1367 24.0603 15.1367H24.0594L22.7405 15.1741C22.5506 15.1795 22.3857 15.3043 22.3287 15.4852M32.6747 16.8755L25.2608 18.0563M32.6747 16.8755L32.6581 16.8518C32.6587 16.8514 32.6592 16.851 32.6598 16.8506M32.6747 16.8755L32.6616 16.8497L32.6598 16.8506M22.3287 15.4852C22.2717 15.6661 22.3341 15.863 22.4865 15.9762L25.2351 18.0371L25.2475 18.0306L25.2608 18.0563M22.3287 15.4852L22.3563 15.4939M22.3287 15.4852L22.3563 15.4939L22.3563 15.4939M25.2608 18.0563L25.2434 18.0794L25.2323 18.0711L25.2608 18.0563ZM22.3563 15.4939C22.3029 15.6632 22.3613 15.8473 22.5037 15.953L22.5038 15.9531L25.2781 18.0332L25.315 18.0608L25.2741 18.082L23.0907 19.2165L23.0831 19.2204L23.0746 19.2196C22.9374 19.2064 22.6728 19.1518 22.3958 19.0891C22.118 19.0262 21.8254 18.9546 21.6312 18.9069C21.1262 18.7843 21.0534 18.7679 20.9697 18.7679H20.0785C19.9026 18.7679 19.7451 18.8787 19.6859 19.0446C19.6268 19.2103 19.6784 19.3953 19.8151 19.5071C20.014 19.6694 20.6237 20.1556 21.324 20.6011C21.6742 20.8239 22.0464 21.0361 22.4009 21.1925C22.756 21.3492 23.0905 21.4487 23.3661 21.4487C23.5539 21.4487 23.7178 21.4067 23.8308 21.3396L23.8324 21.3386L23.8325 21.3387L32.6598 16.8506M22.3563 15.4939L32.6598 16.8506M22.3563 15.4939C22.4096 15.3247 22.5638 15.2081 22.7413 15.2031L22.7413 15.2031L24.0598 15.1656H24.0603C24.8271 15.1656 25.5684 15.3947 26.217 15.8265L26.217 15.8267L26.2197 15.8281L27.7829 16.6453L27.7972 16.6528L27.8111 16.6445L27.8847 16.6007L30.4091 15.4142L30.4094 15.4141C31.1608 15.0489 31.926 15.1092 32.6485 15.6035L22.3563 15.4939Z"
				fill="#595959"
				stroke="#A8A8A8"
				strokeWidth="0.0578425"
			/>
		</svg>
	);
};

const IconContainer = styled.div`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid ${(props) => props.color};
	border-radius: 50%;
	width: 44px;
	height: 44px;
	box-sizing: border-box;
	svg circle {
		stroke: ${(props) => props.color};
	}
`;

const HistoryContainer = styled.div`
	width: 100%;
	height: 100vh;
`;
const MilestonesContainer = styled.div`
	height: 100vh;
	margin-top: 100px;
	width: 50vw;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	position: absolute;
	z-index: 1;
	left: 25%;

	@media (max-width: 1200px) {
		width: 70vw;
		left: 15%;
	}

	@media (max-width: 991px) {
		width: 90vw;
		left: 0;
		padding-left: 30px;
	}

	.hidden {
		opacity: 0;
	}

	.active {
		transform: translateY(-100%);
	}
	.animation__backInRight {
		animation-duration: 0.6s;
		animation-name: backInRight;
	}
	.animation__backOutRight {
		animation-duration: 0.6s;
		animation-name: backOutRight;
	}

	.animation__backInLeft {
		animation-duration: 0.6s;
		animation-name: backInLeft;
	}
	.animation__backOutLeft {
		animation-duration: 0.6s;
		animation-name: backOutLeft;
	}

	@keyframes backInLeft {
		0% {
			transform: translateX(-2000px);
		}
		100% {
			transform: translateX(0);
		}
	}
	@keyframes backOutLeft {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-2000px);
			display: none;
		}
	}
	@keyframes backInRight {
		0% {
			transform: translateX(2000px);
		}
		100% {
			transform: translateX(0);
		}
	}
	@keyframes backOutRight {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(2000px);
			display: none;
		}
	}
`;

const DotOuter = styled.div`
	position: absolute;
	border-radius: 50%;
	height: 24px;
	width: 24px;
	/* top: 12px; */
	z-index: 100;
	transition: all 0.3s;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const DotInner = styled.div`
	border-radius: 50%;
	height: 12px;
	width: 12px;
	z-index: 3;
	transition: all 0.3s;
	background-color: white;
`;

const DescriptionContainer = styled.div`
	width: 100%;
	z-index: 10;
	padding: 6vh 20px 0 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 576px) {
		padding: 0;
	}
`;

const WrapperContent = styled.div`
	flex-direction: column;
	align-items: center;
`;
